export default class Album {
  constructor(name, description, isPublished = false, albumMedias = []) {
    this.name = name;
    this.description = description;
    this.is_published = isPublished;
    this.album_medias = albumMedias;
  }
}
